import parse from 'html-react-parser';
import { useEffect } from 'react';
import { setHeaderHtml, useAppState } from '../../hooks/app-state';
import Skeleton from 'react-loading-skeleton';
import { getHeaderHtml, initHeader } from '../../services/header.service';
import { getApplicationPaths } from '../../app-context/accounts-context';
import { useNavigate } from 'react-router';

export function Header() {
    const navigate = useNavigate();
    const [rawHeader] = useAppState('rawHeader');

    useEffect(() => {
        if (!rawHeader) {
            getHeaderHtml().then((html) => {
                setHeaderHtml(html);
            });
            return;
        }

        initHeader(navigate);
    }, [rawHeader, navigate]);

    if (!rawHeader) {
        return (
            <Skeleton height={36} />
        );
    }

    const applicationPaths = getApplicationPaths();

    return (
        <>
            {parse(rawHeader)}
            <form method='POST' action={applicationPaths.logout} id='accounts-log-out' ></form>
        </>
    );
}

